import type { FaireProductEntity } from "../../entity_types/product";

export const p_5n8nj76687: FaireProductEntity = {
  token: "p_5n8nj76687",
  type: "product",
  name: "Vintage Red Heart Zircon 18K Gold Plated S.Steel Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/fb5ad484ddac32fdc6323544cdda9aa75a7f9c7fcad365861629bba32779a3c9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d186abbac8cd3076eedf114178b9821f883631a7a442b25a68290271813efc36.jpeg",
    "https://cdn.faire.com/fastly/c24b5e9f38fbd48519e4d88ab2f5f1dbe04802d41389eab930f4a84560a9dfe8.jpeg",
    "https://cdn.faire.com/fastly/d00ac7bb1ee3c6d53275f527cf328b3d0e7e01d180de0e31104dddfaa14f9fca.jpeg",
  ],
  priceDollars: 10.8,
  description:
    "Type: Ring\nMaterial : 316L Stainless steel ，Zircon，18K gold plated\nSize ： Please refer to Size chart of rings\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts \n",
  tags: [],
  msrpDollars: 21.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:30.560Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
